import React from 'react';
import { Row } from 'react-bootstrap';
import {
  BsBarChartLine,
  BsCalendarCheck,
  BsClipboardData,
  BsCreditCard,
  BsCurrencyDollar,
  BsPeople,
  BsPersonCheck,
} from 'react-icons/bs';
import StatCard from './StatCard';
import Price from '../../components/lakeview/Price';
import Percentage from '../../components/lakeview/Percentage';

const DashboardGlobalStats = ({ stats }) => {
  return (
    <Row className="mb-4">
      <StatCard
        title="Liczba rezerwacji"
        count={true}
        value={stats.totalReservations}
        icon={<BsClipboardData />}
        color="primary"
      />
      <StatCard
        title="Liczba klientów"
        count={true}
        value={stats.totalCustomers}
        icon={<BsPeople />}
        color="success"
      />
      <StatCard
        title="Całkowity dochód"
        value={<Price count={true} value={stats.totalIncome} />}
        icon={<BsCurrencyDollar />}
        color="warning"
      />
      <StatCard
        title="Anulowane rezerwacje"
        value={<Percentage count={true} value={stats.cancelledPercentage} />}
        icon={<BsBarChartLine />}
        color="danger"
      />
      <StatCard
        title="Płatności z góry"
        value={<Percentage count={true} value={stats.prepaidPercentage} />}
        icon={<BsCreditCard />}
        color="info"
      />
      <StatCard
        title="Śr. liczba osób / rezerwację"
        count={true}
        value={stats.avgGuestsPerReservation}
        icon={<BsPersonCheck />}
        color="secondary"
      />
      <StatCard
        title="Śr. długość pobytu (dni)"
        count={true}
        value={stats.avgNightsPerReservation}
        icon={<BsCalendarCheck />}
        color="primary"
      />
      <StatCard
        title="Średni dochód / rezerwację"
        value={<Price count={true} value={stats.avgIncomePerReservation} />}
        icon={<BsCurrencyDollar />}
        color="info"
      />
    </Row>
  );
};

export default DashboardGlobalStats;
